import { render, staticRenderFns } from "./detail-drawer.vue?vue&type=template&id=353e8f79&scoped=true&"
import script from "./detail-drawer.vue?vue&type=script&lang=js&"
export * from "./detail-drawer.vue?vue&type=script&lang=js&"
import style0 from "./detail-drawer.vue?vue&type=style&index=0&id=353e8f79&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e8f79",
  null
  
)

export default component.exports